import { SmartLink } from "@/components/SmartLink";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export const NotFound = () => {
  const { t, lang } = useLanguage();
  usePageMeta({ title: "404 – HuntersMapp", description: "", path: "/404", lang, noindex: true });
  return (
    <section className="mx-auto max-w-3xl px-5 pb-24 pt-40 text-center sm:px-6">
      <p className="eyebrow">404</p>
      <h1 className="font-display mt-5 text-4xl sm:text-5xl">Seite nicht gefunden / Page not found</h1>
      <SmartLink href="/" className="btn btn-ghost mt-10 px-6 py-3 text-sm">
        {t.legal.back}
      </SmartLink>
    </section>
  );
};
